/* @flow */

import * as React from 'react';
import { mapProps } from 'recompose';
import styled from '@emotion/styled';

type Props = {
  direction?: 'asc' | 'desc',
  name?: string
};

const defaultProps = {
  direction: undefined,
  name: undefined
};

const SortIndicatorLine = styled.span({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});

function SortIndicator({ direction, name }: Props) {
  if (!name) {
    return <SortIndicatorLine>Sort By</SortIndicatorLine>;
  }

  return (
    <SortIndicatorLine>
      {direction === 'asc' && <span className="ion-arrow-up-c" />}
      {direction === 'desc' && <span className="ion-arrow-down-c" />} {name}
    </SortIndicatorLine>
  );
}

SortIndicator.defaultProps = defaultProps;

const enhancer = mapProps(props => ({
  direction: props.direction,
  name: {
    average: 'Average',
    barrier: 'Barrier',
    exposure: 'Exposure %',
    form: 'Form',
    homeAbbr: 'Match',
    name: 'Name',
    number: 'Number',
    place: 'Place',
    placeProjected: 'Place',
    popularity: 'Selected',
    position: 'Position',
    salary: 'Salary',
    score: 'Points',
    entryCount: '#Sel',
    totalLineups: '#Teams',
    valueForMoney: 'Value',
    weight: 'Weight',
    win: 'Win',
    winProjected: 'Win'
  }[props.field]
}));

export default enhancer(SortIndicator);
